export const width = 368;
export const height = 300;
export default __webpack_public_path__ + "static/2.249d40c3.svg";